<main>
  <p-toast position="bottom-right" key="br"></p-toast>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Yarn_Title' | translateWF: 'Yarn' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button label="{{ 'Common_Add' | translateWF: 'Add' }}" icon="pi pi-plus" (click)="openYarnModal()" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="cs-page-list-grid">
        @if (filterConfig() && showFilters()) {
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        }

        <p-panel [header]="'Yarn_Title' | translateWF: 'Yarn'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>

          <p-card data-variant="compact">
            <p-table [value]="yarns()" selectionMode="single" (onSort)="onSort($event)" [lazy]="true">
              <ng-template pTemplate="header">
                <tr class="primary__header">
                  <th pSortableColumn="code">
                    {{ 'Yarn_Code' | translateWF: 'Code' }}
                    <p-sortIcon field="code" />
                  </th>

                  <th pSortableColumn="longDescription">
                    {{ 'Yarn_Description' | translateWF: 'Description' }}
                    <p-sortIcon field="longDescription" />
                  </th>
                  <th>
                    {{ 'Common_Status' | translateWF: 'Status' }}
                  </th>
                  <th></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                @let yarn = getRowData(rowData);
                <tr class="cursor-pointer" (click)="openYarnModal(yarn)">
                  <td class="truncate">
                    <a>
                      {{ yarn.code }}
                    </a>
                  </td>
                  <td class="truncate max-w-[10rem]">
                    {{ yarn.longDescription }}
                  </td>
                  <td>{{ statuses()[yarn.status] | pascalToNormalCase }}</td>
                  <td class="!text-end">
                    @if (!isReadyForProduction(yarn)) {
                      <p-button icon="pi pi-trash" variant="outlined" (click)="deletePopup($event, yarn)" [disabled]="!canEdit()" />
                    }
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4">
                    {{ 'Yarn_Not_Found' | translateWF: 'Yarns not found' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <p-paginator
              [rows]="pageSize()"
              [totalRecords]="totalRecords()"
              [first]="(currentPage() - 1) * pageSize()"
              (onPageChange)="onPageChange($event)"
              [rowsPerPageOptions]="[15, 25, 50]"
              class="mt-4"
            />
          </p-card>
        </p-panel>
      </div>
    </section>
  </div>
  <p-confirmdialog key="deleteYarn" />
</main>
